import { createAction } from '../../../core/helpers'

import { FETCH_MENU_CURATION_TASK } from '../action-types'

export const cleanupFetchMenuCurationTask = createAction(
  FETCH_MENU_CURATION_TASK.CLEANUP,
)
